import BaseFormControl from "./BaseFormControl";

class DummyFormControl extends BaseFormControl {
    month(): JSX.Element {
        throw new Error("Method not implemented.");
    }

    date(): JSX.Element {
        throw new Error("Method not implemented.");
    }

    search(): JSX.Element {
        throw new Error("Method not implemented.");
    }

    text(): JSX.Element {
        throw new Error("Method not implemented.");
    }

    inputMask(): JSX.Element {
        throw new Error("Method not implemented.");
    }

    label(): JSX.Element {
        throw new Error("Method not implemented.");
    }

    password(): JSX.Element {
        throw new Error("Method not implemented.");
    }

    email(): JSX.Element {
        throw new Error("Method not implemented.");
    }

    number(): JSX.Element {
        throw new Error("Method not implemented.");
    }

    radio(): JSX.Element {
        throw new Error("Method not implemented.");
    }

    checkbox(): JSX.Element {
        throw new Error("Method not implemented.");
    }

    select(): JSX.Element {
        throw new Error("Method not implemented.");
    }

    multiselect(): JSX.Element {
        throw new Error("Method not implemented.");
    }

    button(): JSX.Element {
        throw new Error("Method not implemented.");
    }

    file(): JSX.Element {
        throw new Error("Method not implemented.");
    }

    hint(): JSX.Element {
        throw new Error("Method not implemented.");
    }

    phone(): JSX.Element {
        throw new Error("Method not implemented.");
    }
}

export default DummyFormControl;
